module.exports = __webpack_public_path__ + "static/img/ewm1.446a269.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/ewm1.png
// module id = zPe5
// module chunks = 1